import { storage } from '@/utils/utils';

const DATASOURCE_EXPLANATION_STORAGE_KEY = 'DBI_DATASOURCE_EXPLANATION_STATE';

export const getDataSourceExplanationInitialState = (domain: string): boolean => {
  try {
    const dataSourceExplanationInitialStateMap = storage.getItem(DATASOURCE_EXPLANATION_STORAGE_KEY);
    return dataSourceExplanationInitialStateMap?.[domain] ?? true;
  } catch (exception) {
    return true;
  }
};

export const setDataSourceExplanationInitialState = (domain: string, state: boolean) => {
  const dataSourceExplanationInitialStateMap = storage.getItem(DATASOURCE_EXPLANATION_STORAGE_KEY);
  const dataSourceExplanationInitialStateMapNew = { ...dataSourceExplanationInitialStateMap, [domain]: state };
  storage.setItem(DATASOURCE_EXPLANATION_STORAGE_KEY, dataSourceExplanationInitialStateMapNew);
};
